import React from 'react'
import Jumbotron from './Jumbotron'
import GetInTouch from './GetInTouch'
import Container from './styles'

const Support = () => {
  return (
    <Container>
      <Jumbotron />
      <GetInTouch />
    </Container>
  )
}

export default Support
